import React, {lazy} from 'react';
import {Redirect} from 'react-router-dom';
import DashboardLayout from './layouts/Dashboard';

const routes = [
    {
        path: '/',
        exact: true,
        component: () => <Redirect to="/dashboard"/>
    },
    {
        route: '*',
        component: DashboardLayout,
        routes: [
            {
                path: '/login',
                exact: true,
                component: lazy(() => import('./views/Login'))
            },
            {
                path: '/dashboard',
                exact: true,
                component: lazy(() => import('./views/Dashboard'))
            }
        ]
    }
];

export default routes;
